import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                    */
const BrandListGroup = ({ title, children, className }) => /* @__PURE__ */ React.createElement("li", { className: classnames("brand-list-group", className) }, /* @__PURE__ */ React.createElement(
  Heading,
  {
    variant: "subheading1",
    className: classnames("brand-list-group__title", {
      "brand-list-group__title--empty": !title?.length
    })
  },
  title
), children);
export {
  BrandListGroup as default
};
//# sourceMappingURL=BrandListGroup.js.map
